<!-- 由 suu 创建于 2022-01-24 星期一 -->
<!-- 减脂营4.0阶段性问卷 -->
<template>
  <div class="stage-question" v-if="questionData">
    <!-- 头部 -->
    <div class="sq-title">阶段性测试问卷</div>
    <!-- 进度 -->
    <QuesSteps
      :total="quesTotal"
      :current="current"
      @prestep="handelPrestep"
    ></QuesSteps>
    <!-- 内容 -->
    <div class="sq-cent">
      <!-- <div class="sc-title">{{ questionData.sub_title }}</div> -->
      <!-- 选项 -->
      <QuesItem
        v-for="(item, index) in questionData.sub_list"
        v-show="index === current - 1"
        :info="item"
        :final="current >= quesTotal"
        @next="handelNext"
        :key="index"
      >
      </QuesItem>
      <!-- 反馈 -->
      <QuesFeedback
        :info="feedbackInfo"
        :final="current >= quesTotal"
        v-if="feedbackInfo"
        @next="handelFbackNext"
      ></QuesFeedback>
    </div>
  </div>
</template>

<script>
import QuesSteps from './ponents/ques-steps.vue'
import QuesItem from './ponents/ques-item.vue'
import QuesFeedback from './ponents/ques-feedback.vue'
import { couponList } from './data'
export default {
  name: 'stage-question',

  components: { QuesSteps, QuesItem, QuesFeedback },

  props: {},

  data() {
    return {
      questionData: null,
      current: 1,
      pid: '',
      feedbackInfo: null,
      step: 1, // 当前是第几阶段
      couponList // 优惠券列表
    }
  },

  computed: {
    quesTotal() {
      return (
        (this.questionData &&
          this.questionData.sub_list &&
          this.questionData.sub_list.length) ||
        0
      )
    }
  },

  watch: {},

  created() {
    this.getQuery()
    this.getQuestionList()
  },

  mounted() {},

  destroyed() {},

  methods: {
    /**
     * 上一题
     */
    handelPrestep() {
      if (this.current > 1) {
        this.current--
      }
    },
    /**
     * 反馈点击下一题
     */
    handelFbackNext() {
      if (this.current < this.quesTotal) {
        this.current++
        this.feedbackInfo = null
      } else {
        // 最后反馈页点击领取奖励
        this.getCoupon()
      }
    },
    /**
     * 下一题
     */
    handelNext(active) {
      this.feedbackInfo =
        this.questionData.sub_list[this.current - 1].feedback || null
      this.changeQuestionData(this.current - 1, active)
      if (this.current >= this.quesTotal) {
        // 最后提交 (改为点击最后反馈页按钮才掉接口更改状态)
        this.submitTask()
      } else if (!this.feedbackInfo) {
        this.current++
      }
    },
    /* 根据用户选择的数据修改questionData */
    changeQuestionData(current, active) {
      if (
        !this.questionData.sub_list ||
        !this.questionData.sub_list[current] ||
        !Array.isArray(active) ||
        !active.length
      ) {
        return
      }
      let item = this.questionData.sub_list[current]
      let chooseValue
      if (active.length == 1) {
        chooseValue = item.field_unit[active[0]].key
      } else {
        let arr = []
        active.map((item1) => {
          arr.push(item.field_unit[item1].key)
        })
        chooseValue = arr
      }
      console.log()
      this.$set(this.questionData.sub_list[current], 'chooseValue', chooseValue)
    },
    /**
     * 提交
     */
    submitTask() {
      let task_info = JSON.stringify(this.questionData)
      this.$toast.loading('提交中··')
      this.$http
        .postApp('member/AppCamp/testStepTask', {
          pid: this.$route.query.pid, // 营期id
          day: '', // 日期 默认当天
          step: this.step,
          task_info // 完成明细 JSON 字符串
        })
        .then((res) => {
          this.$toast.clear()
          if (res.data.code == 200) {
          } else {
            this.$toast(res.data.msg)
          }
        })
        .catch(() => {
          this.$toast.clear()
        })
    },
    /**
     * 获取问卷
     */
    getQuestionList() {
      this.$toast.loading('加载中...')
      this.$http
        .postApp('member/AppCamp/getStepQue', {
          step: this.$route.query.step, // 营期阶段
          pid: this.pid
        })
        .then((res) => {
          if (res.data.code == 200) {
            if (res.data.data && res.data.data.is_task == 0) {
              this.questionData = res.data.data.que[0]
            } else {
              this.questionData = {}
              let subList = res.data.data.que[0].sub_list
              this.feedbackInfo = subList[subList.length - 1].feedback
            }
          } else {
            this.$toast(res.data.msg)
          }
        })
        .catch(() => {})
        .finally(() => {
          this.$toast.clear()
        })
    },
    getQuery() {
      this.step = this.$route.query.step < 1 ? 1 : +this.$route.query.step
      this.pid = this.$route.query.pid
    },
    // 去获取优惠券
    getCoupon() {
      let index = this.step > this.couponList.length ? 0 : this.step - 1
      if (this.$http._isApp()) {
        this.$betterwe.onAppPageRoute({
          path: 'miniProgram', //跳转页面路径
          //跳转所需参数
          params: [
            { key: 'userName', value: 'gh_22053f67c0f7' },
            { key: 'path', value: this.couponList[index].path }
          ]
        })
        return
      }
      wx.miniProgram.getEnv((res) => {
        if (res.miniprogram) {
          // 当前是微信小程序环境
          let data = {
            appid: 'wx52b492586f86e02b',
            path: this.couponList[index].path
          }
          data.path = data.path ? encodeURIComponent(data.path) : data.path
          wx.miniProgram.navigateTo({
            url:
              '/pages/navigateToOtherMiniProgram/index?data=' +
              JSON.stringify(data)
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 750) * 100vw;
}
.stage-question {
  width: 100vw;
  min-height: 100vh;
  box-sizing: border-box;
  overflow: hidden;
  overflow-y: auto;
  padding: 0 4.8vw;
  background-color: #f1f1f1;
  display: flex;
  flex-direction: column;
  align-items: center;
  .sq-title {
    margin-top: 20px;
    margin-bottom: 6px;
    text-align: center;
    font-size: 15px;
  }
  .sq-cent {
    flex: 1;
    // min-height: 550px;
    width: 100%;
    box-sizing: border-box;
    margin-top: 31px;
    background-color: #fff;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 50px;
    padding-bottom: 20px;
    .sc-title {
      font-size: 15px;
      color: rgba(0, 0, 0, 0.5);
      margin-top: 12px;
    }
  }
}
</style>
